import { render, staticRenderFns } from "./PlacementEventsListItem.vue?vue&type=template&id=24627f50"
import script from "./PlacementEventsListItem.vue?vue&type=script&lang=js"
export * from "./PlacementEventsListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports